import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class CopyTextToClipboard extends Component {

    static propTypes = {
        inputText:        PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        i18nButtonLabel:  PropTypes.string.isRequired,
        i18nSuccessLabel: PropTypes.string.isRequired
    };

    static defaultProps = {
        inputText: ''
    };

    constructor(props) {
        super(props);

        this.state = {
            isTextCopied: false
        };

        this.timer = null;
        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    copyToClipboard() {
        this.setState({isTextCopied: true});
        this.clipboardInput.select();
        document.execCommand('copy');
        this.timer = setTimeout(() => {this.setState({isTextCopied: false})}, 3000);
    };


    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        return (
            <div className='copy-to-clipboard'>
                {
                    !this.state.isTextCopied ?
                        <button type="button" className='button-primary-sm' onClick={this.copyToClipboard}>
                            <FormattedMessage id={this.props.i18nButtonLabel} />
                        </button>
                        :
                        <button type="button" className='button-primary-sm copy-to-clipboard__success'>
                            <div className='container'>
                                <div className='mirror-button-message'>
                                    <FormattedMessage id={this.props.i18nButtonLabel} />
                                </div>
                                <div className='success-message'>
                                    <span className='la-Check' /> <FormattedMessage id={this.props.i18nSuccessLabel} />
                                </div>
                            </div>
                        </button>
                }
                <input type="text"
                       className="copy-to-clipboard__input"
                       ref={(clipboardInput) => this.clipboardInput = clipboardInput}
                       value={this.props.inputText} />
            </div>
        )
    }
}

export default CopyTextToClipboard;



// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/CopyTextToClipboard.jsx